
const confirmationData = {
    showTradeinSection: ["US"]
}

export default confirmationData;
